import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Plus } from '@zooplus/icons';

import styles from './StoredCreditCards.module.scss';

type AddCardProps = {
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
};

const NewCardActionButton: React.FC<AddCardProps> = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.creditCardContainer}>
      <div
        className={classNames(styles.creditCard, styles.addCard)}
        data-zta="addNewCC"
        onClick={onClick}>
        <div>
          <Plus />
        </div>
        <div>{t('checkout.payment.creditcard.addnew')}</div>
      </div>
    </div>
  );
};

export default NewCardActionButton;
